import { makeStyles, Theme, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      width: '100%',
      borderRadius: theme.spacing(1),
      alignContent: 'center',
    },
    menuItem: {
      minWidth: theme.spacing(21),
      borderRadius: theme.spacing(1),
    },
    select: {
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(1),
      paddingLeft: theme.spacing(2),
    },
  }),
);

export default useStyles;
